export default "__VITE_ASSET__Blen9ASd__"